var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlutter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1924",
    "data-name": "Rectangle 1924",
    width: 52,
    height: 52,
    transform: "translate(744 596)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_25",
    "data-name": "Mask Group 25",
    transform: "translate(-744 -596)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flutter-logo",
    transform: "translate(750.747 597.779)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19744",
    "data-name": "Path 19744",
    d: "M24.246.237,39.125.221,14.162,25.172l-6.506,6.47L.253,24.23Zm-.138,22.278c.193-.255.548-.129.818-.162l14.187,0L26.183,35.274l-7.441-7.4Z",
    transform: "translate(0 0)",
    fill: "#44d1fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19746",
    "data-name": "Path 19746",
    d: "M3.608,16.008,11.025,8.6,18.465,16l.031.033-7.47,7.4L3.608,16.008Z",
    transform: "translate(7.717 19.278)",
    fill: "#1fbcfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19747",
    "data-name": "Path 19747",
    d: "M5.855,18.252l7.47-7.4,12.9,12.917c-4.861.011-9.72,0-14.579.007-.277.062-.448-.191-.625-.348L5.855,18.252Z",
    transform: "translate(12.888 24.456)",
    fill: "#08589c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutter);
export default __webpack_public_path__ + "static/media/flutter.f9430be0fa58874b164bf19e3f4b3c2a.svg";
export { ForwardRef as ReactComponent };